import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';
const sendDevice = async (data: CustomerDeviceCodeProps) => {
  const authToken = getCookie(authKeys.authToken);
  const urlFetchSendDevice = authToken ? apiConfig.routes.customer.sendDevice : apiConfig.routes.customer.sendDevicePublic;
  await api.post(urlFetchSendDevice, data);
};
export const useSendDevice = () => {
  return useMutation({
    mutationFn: sendDevice
  });
};
type CustomerDeviceCodeProps = {
  device_code: string;
  type: string;
  agent: string;
  device_ip?: string;
  state?: string;
  city?: string;
  country?: string;
};